import React from "react";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";

import TwitterIcon from '@mui/icons-material/Twitter';
import TelegramIcon from '@mui/icons-material/Telegram';

const LockerMenu = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: "Home",
      link: "/#home",
    },
    {
      title: "About",
      link: "#about",
    },
    {
      title: "Stats",
      link: "#Stats",
    },
    {
      title: <TwitterIcon style={{fontSize:"30px"}} />,
      link: "https://twitter.com/FlokicoinPulse",
      target:"blank"
    },
    {
      title: <TelegramIcon  style={{fontSize:"30px"}}/>,
      link: "https://t.me/flokicoinpulse",
      target:"blank"
    },
  ];
  return (
    <>
    <div
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
    </div>
    </>
  );
};

export default LockerMenu;
